// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  HomeRepairServiceOutlined,
  SellOutlined,
} from '@/constants/hardfin-standard-icons';
import { TransactionType } from '@/project/api/types';
import { Chip, Tooltip } from '@mui/material';

const TRANSACTION_TYPE_CONFIG: Record<
  TransactionType,
  {
    label: string;
    tooltip: string;
    color: 'success' | 'info';
    icon: React.ReactElement;
  }
> = {
  SALE: {
    label: 'Sale',
    tooltip:
      'Ownership goes to the customer (title transfer) as part of this transaction',
    color: 'success',
    icon: <SellOutlined fontSize="small" />,
  },
  SERVICE: {
    label: 'Service',
    tooltip:
      'Ownership is retained by your organization (vendor) and provided as-a-service (HaaS)',
    color: 'info',
    icon: <HomeRepairServiceOutlined fontSize="small" />,
  },
};

interface Props {
  transactionType: TransactionType;
}

/**
 * Displays a transaction type as a color-coded chip with an icon and tooltip.
 * Sale (green) indicates ownership transfers to the customer.
 * Service (blue) indicates the vendor retains ownership and provides HaaS.
 */
export function TransactionTypeChip(props: Props) {
  const config = TRANSACTION_TYPE_CONFIG[props.transactionType];

  return (
    <Tooltip arrow title={config.tooltip}>
      <Chip
        icon={config.icon}
        label={config.label}
        size="small"
        color={config.color}
      />
    </Tooltip>
  );
}
